module.exports = "<!--时间选择器-->\n<input time-picker placeholder=\"结束时间\" type=\"text\" ng-model=\"timePicker1\">";